import { Stack, Typography } from '@mui/material';
import type { Customer } from '@vy/types';
import { vyDate } from '@vy/utils';
import { useNavigate } from 'react-router-dom';

type CustomerNavIdentityProps = {
  customer: Customer;
};

export const CustomerNavIdentity: React.FC<CustomerNavIdentityProps> = ({ customer }) => {
  const navigate = useNavigate();

  return (
    <Stack sx={{
      marginLeft: "16px"
    }}>
      <Typography
        onClick={() => navigate(`/customers/${customer.id}/overview`)}
        sx={{
          fontWeight: 400,
          marginBottom: "6px",
          fontSize: 24,
          lineHeight: "33px",
          color: "text.primary",
          cursor: 'pointer'
        }}>
        {customer.name}
      </Typography>
      <Stack spacing="6px">
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 12,
            color: "text.secondary"
          }}>
          Registered: {vyDate(customer.createdAt).format('MMMM D, YYYY')}
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 12,
            color: "text.secondary"
          }}>
          ID: {customer.id}
        </Typography>
      </Stack>
    </Stack>
  );
};
